import { getLinks, getLinksLength } from '../api/shortLinks';
import { setLinks, setLinksLength } from '../actions/mw_links';

// Max limit on MW side
const FETCH_LINKS_LIMIT = 100;

export const fetchMWLinks = (enqueueSnackbar) => async (dispatch) => {
  const fetchOptions = {
    offset: 0,
    total: 0,
  };

  const links = [];

  try {
    do {
      const response = await getLinks({
        limit: FETCH_LINKS_LIMIT,
        offset: fetchOptions.offset,
      });

      fetchOptions.total = response.total;
      fetchOptions.offset += response.links.length;

      links.push(...response.links);
    } while (links.length !== fetchOptions.total);

    dispatch(setLinks({ links }));
  } catch (error) {
    if (error?.status !== 401) {
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  }
};

export const requestMWLinksLength = (enqueueSnackbar) => async (dispatch) => {
  try {
    const response = await getLinksLength();

    dispatch(setLinksLength({ linksLength: response.longestLinkLength }));
  } catch (error) {
    if (error?.status !== 401) {
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  }
};
